<template>
    <div class="topnav hidden-xs" v-bind:class="{ agencyisloggedin: getFlagSharedAgencyLoggedIn === true }">
        <div class="container">
            <!-- >>> Change Language --------------------------------------- -->
            <ul class="quick-menu pull-left">
                <li class="ribbon">
                    <a>{{ language[getCurrentLocale] }} ({{ getCurrentLocale }})</a>
                    <ul class="menu mini">
                        <li v-bind:class="{ active: getCurrentLocale === 'de' }">
                            <a href="#" title="Deutsch" v-on:click.prevent="changeLanguage('de')">Deutsch</a>
                        </li>
                        <li v-bind:class="{ active: getCurrentLocale === 'en' }">
                            <a href="#" title="English" v-on:click.prevent="changeLanguage('en')">English</a>
                        </li>
                    </ul>

                    <v-dialog/>
                </li>
            </ul>


            <!-- >>> User Login -------------------------------------------- -->
            <!-- <ul class="quick-menu pull-right" v-if="get_Flag_Auth_UserLoggedIn === false">
                <li><a href="#sundair-login" class="soap-popupbox"> {{ userlogin[getCurrentLocale] }}</a></li><i class="soap-icon-user" style="font-size: 18px; color: white; line-height: 150%; margin-left: 7px;"></i>
            </ul>
            <ul class="quick-menu pull-right" v-if="get_Flag_Auth_UserLoggedIn === true">
                <li><a href="#" @click.prevent="onClick_UserLogout()">{{ user_email}} - {{ userlogout[getCurrentLocale] }}</a></li><i class="soap-icon-user" style="font-size: 18px; color: white; line-height: 150%; margin-left: 7px;"></i>
            </ul> -->


            <!-- >>> Dialog ------------------------------------------------ -->
             <v-dialoglogout/>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                language: {
                    en: 'Language',
                    de: 'Sprache',
                },
                agencylogin: {
                    en: 'Agency Login',
                    de: 'Agentur Login',
                },
                agencylogout: {
                    en: 'Agency Logout',
                    de: 'Agentur Logout',
                },
                userlogin: {
                    en: 'Your Sundair Account',
                    de: 'Ihr Sundair Konto',
                },
                userlogout: {
                    en: 'Log out',
                    de: 'Abmelden',
                },
                alertno: {
                    en: 'No',
                    de: 'Nein',
                },
                alertyes: {
                    en: 'Yes',
                    de: 'Ja',
                },
                dialogtitle: {
                    en: 'Change Language?',
                    de: 'Sprache ändern?',
                },
                dialogtext: {
                    en: 'You want to change the language?',
                    de: 'Sie wollen die Sprache ändern?',
                },
                dialogtitlelogout: {
                    en: 'Log out?',
                    de: 'Abmelden?',
                },
                dialogtextlogout: {
                    en: 'You want to log out from your SUNDAIR Account?',
                    de: 'Sie wollen sich von Ihrem SUNDAIR Konto abmelden?',
                },
                // >>> ------------------------------------
                user_email: null, // email in header of user
                // >>> ------------------------------------
                lang: 'de'
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedAgencyLoggedIn',
                'get_Flag_Auth_UserLoggedIn', // is a User logged in?
                'get_authorizationUserdata' // get user date from ls
            ]),

        }, // eo  computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/header/LanguageList.vue >>> created');
            eventBus.$on('call_travelcenter_updateProfile_updatePasswordSuccess', this.onEmit_UpdatePasswordSuccess);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Check for Sundair User here.
        *
        */
		mounted: function () {

            let me = this;


            me.$toc('>>> shared/header/LanguageList.vue >>> mounted');
            // >>> User in localStorage? ------------------
            if (this.get_authorizationUserdata !== null) {
                this.user_email = this.get_authorizationUserdata.email; // make visible
                this.actn_set_Flag_Auth_UserLoggedIn(true);
            }

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/header/LanguageList.vue >>> beforeDestroy');
            eventBus.$off('call_travelcenter_updateProfile_updatePasswordSuccess', this.onEmit_UpdatePasswordSuccess);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCurrentLocale',
                'actn_auth_logout',
                'actn_set_Flag_Auth_UserLoggedIn',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_UserLogout()
            *
            * Desc:
            * Note: Step 1 of 2.
            *
            */
            onClick_UserLogout: function () {

                var me = this;


                me.$toc('>>> shared/header/LanguageList.vue >>> onClick_UserLogout');
                this.wannaLogOutDialog();

            }, // eo function onClick_UserLogout()


            /*******************************************************************
            * onEmit_UpdatePasswordSuccess()
            *
            * Desc: React with Logout on Password Change.
            * Note:
            *
            */
            onEmit_UpdatePasswordSuccess: function  () {

                var me = this;


                me.$toc('>>> shared/header/LanguageList.vue >>> onClick_UserLogout');
                me.$modal.hide('dialoglogout');
                me.actn_auth_logout();

            }, // eo function onEmit_UpdatePasswordSuccess()




            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * wannaLogOutDialog()
            *
            * Desc:
            * Note: Step 2 of 2.
            *
            */
            wannaLogOutDialog: function () {

                var me = this;


                me.$toc('>>> shared/header/LanguageList.vue >>> wannaLogOutDialog');
                this.$modal.show('dialog', {
                    title: me.dialogtitlelogout[me.getCurrentLocale],
                    text:  me.dialogtextlogout[me.getCurrentLocale],
                    buttons: [
                        {
                            title: me.alertno[me.getCurrentLocale]
                        },
                        {
                            title: me.alertyes[me.getCurrentLocale],
                            default: true,
                            handler: () => {
                                me.onEmit_UpdatePasswordSuccess(); // logout and hide
                            }
                        }
                    ]
                });

            }, // eo function wannaLogOutDialog()

            /*******************************************************************
            * changeLanguage()
            *
            * Desc:
            * Note:
            *
            * @param {string} language ()
            */
            changeLanguage: function (language) {

                var me = this;


                me.$toc('>>> shared/header/LanguageList.vue >>> changeLanguage');
                this.$modal.show('dialog', {
                    title: me.dialogtitle[me.getCurrentLocale],
                    text:  me.dialogtext[me.getCurrentLocale],
                    buttons: [
                        {
                            title: me.alertno[me.getCurrentLocale]
                        },
                        {
                            title: me.alertyes[me.getCurrentLocale],
                            default: true,
                            handler: () => {
                                me.$modal.hide('dialog');
                                me.lang = language;
                                this.$ls.set('lang', language); // localStorage

                                me.actn_setCurrentLocale(language);

                                setTimeout(function() {
                                    me.$enableChaser(); // #800
                                }, 700);
                            }
                        }
                    ]
                });

            }, // eo function changeLanguage()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .agencyisloggedin  {
        background-color: #3bdd4e !important;
    }


    #header .topnav ul.quick-menu > li > a {
        line-height: 30px;
        display: block;
        font-size: 0.9375em; /* 0.8333em; */
        text-transform: uppercase;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/header/LanguageList.vue